import React from "react";
import { LucideIcon } from "lucide-react";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface ConfigCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  navigate: string;
}

export const ConfigCard: React.FC<ConfigCardProps> = ({
  icon: Icon,
  title,
  description,
  navigate,
}) => {
    const navigateTo = useNavigate();
    const handleNavigate = () => {
        navigateTo(navigate);
    }
  return (
    <div className="flex items-start p-6 h-fit bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition cursor-pointer">
      <div className="flex-shrink-0 bg-blue-50 text-blue-600 rounded-md p-2">
        <Icon className="w-5 h-5" />
      </div>
      <div className="ml-4 flex-1">
        <h3 className="text-lg font-medium text-gray-900">{title}</h3>
        <p className="mt-1 text-sm text-gray-600">{description}</p>
        <button
          onClick={handleNavigate}
          className="mt-3 inline-flex items-center text-blue-600 text-sm font-medium hover:underline"
        >
          Configure <ArrowRight className="ml-1 w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
